import { createContext, useContext } from 'react';

export const FormContext = createContext();
export const useForm = () => useContext(FormContext);
